import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Route, Switch, Router } from 'react-router-dom';

import Routes from './route/Routes';
import ExportRoute from './components/pages/ExportRoute';

import './App.css';
import './style.css';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { WindowDimensionsProvider, UserStateProvider, theme } from './context/Provider';
import { NotificationWrapper } from './components';

const TRACKING_ID = 'G-N561FCDQ9Q';
ReactGA.initialize(TRACKING_ID, { debug: true });

//WindowDimensionProvider is prepared for responsiveness for future dev
export default function App() {
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<UserStateProvider>
					<WindowDimensionsProvider>
						<NotificationWrapper>
							<Routes />
						</NotificationWrapper>
					</WindowDimensionsProvider>
				</UserStateProvider>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}
